import ReactApexChart from 'react-apexcharts';
import "./ChartStyle.scss"
export default function AreaChartItem({data}){
  const values = data.map(obj=>
    obj.value);
    const years = data.map(obj=>
      obj.year);
      const colors = ["#8CAE68", "#FF6347","#B3679B","#FFBA49","#175676","#90A9B7","#3F292B"]
      const random = Math.floor(Math.random() * colors.length);
  const series= [{
    name: 'series1',
    data: values
  }]
  const options= {
    chart: {
      type: 'bar',
      toolbar: {
        show: false
      }
    },plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    colors: [`${colors[random]}`],
    legend: {
      show: false,
    },
    yaxis: {
      title: {
        text: 'CO2 percentage'
      }
    },
    xaxis: {
      categories: years,
      position: 'bottom',
      tickAmount: 10,
    },

  }

  return(
    <div id="chart">
      <ReactApexChart options={options} series={series} height="100%" type="bar" />
    </div>
  );
}